import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { user2faUrl, userActiveSessionsUrl, userProfileUrl } from 'common/config/urls';
import { ACTIVE_SESSIONS_TAB, TWO_FACTOR_AUTH_TAB } from 'common/constants/user';
import { ACCOUNT_SETTINGS_SLUG } from 'dashboard409a/common/constants';

const useAccountSettingsNavItems = () => {
  const { firmSlugParam } = useParams<{ firmSlugParam: string }>();

  return useMemo(
    () =>
      firmSlugParam
        ? [
          { label: 'Settings', value: ACCOUNT_SETTINGS_SLUG, to: userProfileUrl(firmSlugParam) },
          { label: 'Two-Factor Authentication', value: TWO_FACTOR_AUTH_TAB, to: user2faUrl(firmSlugParam) },
          { label: 'Active Sessions', value: ACTIVE_SESSIONS_TAB, to: userActiveSessionsUrl(firmSlugParam) },
        ]
        : [],
    [firmSlugParam]
  );
};

export default useAccountSettingsNavItems;
